<section class="login">
  	<div class="container h-100">
      	<div class="row align-items-center h-100 justify-content-center">
        	<div class="card rounded-0 card-login border-0">
            <div class="text-center mb-3">
              <img src="assets/images/header-logo.png" />
            </div>

            <div class="card-body">
              <crm-alert #alert></crm-alert>

              <loader [loading]="loading"></loader>

              <form *ngIf="!codeVerifyFlag && !loading" [formGroup]="externalAskForm" name="form" class="loginForm" (click)="onSubmit()">
                <div class="form-group row">
                  <label for="inputEmail" class="col-sm-3 col-form-label">Email</label>
                  <div class="col-sm-8">
                    <input type="email"  formControlName="USER_EMAIL" name="USER_EMAIL" id="inputEmail" class="form-control rounded-0" placeholder="Your email" />
                  </div>
                </div>

                
                <div class="row">
                  <div class="col-6 mx-auto">
                    <button [disabled]="!externalAskForm.valid" type="submit" class="btn btn-login btn-lg btn-block rounded-0">
                      Generate Code
                    </button>
                  </div>
                </div>
              </form>
              <form *ngIf="codeVerifyFlag && !loading" [formGroup]="authForm" name="form" class="authForm" (ngSubmit)="onAuthSubmit()">
                <div class="form-group row">
                   <label for="inputEmail" class="col-sm-3 col-form-label">6-digit code</label>
                   <div class="col-sm-8">
                     <input type="email" formControlName="AUTH_CODE" name="AUTH_CODE" id="inputCode"
                       class="form-control rounded-0" numbersOnly maxlength="6" placeholder="Your auth code" />
                   </div>
                </div>
                <div class="row">
                  <div class="col-6 mx-auto">
                    <button [disabled]="!authForm.valid" type="submit" class="btn btn-login btn-lg btn-block rounded-0">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
       		</div>
      	</div>
  	</div>
</section>

